import wSlider from './w-slider.vue';

import { installer } from '#util';

export const Slider = { install: installer([wSlider]) };
export { wSlider };
